module.exports = __webpack_public_path__ + "media/images/landing/second/photo25-2da8770cb96ceb324bf19daf0f96b214.jpg";